export default {
  methods: {
    iconSrc(directory, ext, image) {
      return this.imgsrc(directory, `${image}.${ext}`)
    },

    imgsrc(directory, image) {
      return `./assets/${directory}/${image}`
    },
  },
}
